import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import Nav from "./components/nav/Nav";
import Home from "./components/home/Home";
import About from "./components/about/About";
import Skills from "./components/skills/Skills";
import Portfolio from "./components/portfolio/Portfolio";
import Contactus from "./components/contactus/Contactus";

function App() {
  return (
    <div className="app">
      <Nav />
      <Home />
      <About />
      <Skills />
      <Portfolio />
      <Contactus />
    </div>
  );
}

export default App;
